import { ReactNode } from 'react';

interface EmptyStateProps {
  icon?: ReactNode;
  title: string;
  description?: string;
  action?: ReactNode;
}

function EmptyState({ icon, title, description, action }: EmptyStateProps) {
  return (
    <div className="claude-empty-state rounded-2xl border border-[var(--ff-border)] bg-[var(--ff-surface-alt)] px-6 text-center shadow-[0_12px_28px_rgba(0,0,0,0.06)]">
      {icon && (
        <div className="claude-empty-state-icon bg-[var(--ff-surface)] border border-[var(--ff-border)] shadow-inner text-telegram-text">
          {icon}
        </div>
      )}
      <h3 className="claude-empty-state-title text-telegram-text">{title}</h3>
      {description && (
        <p className="claude-empty-state-description text-telegram-hint">{description}</p>
      )}
      {action && <div className="mt-4">{action}</div>}
    </div>
  );
}

export default EmptyState;
